import axios from 'axios';

const api = axios.create({ baseURL: '/api' });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('artflow_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      const path = window.location.pathname;
      // Don't redirect if on auth pages
      const isAuthPage = path === '/' ||
                         path === '/admin/login' ||
                         path === '/admin/it-ops-login' ||
                         path === '/auth/callback' ||
                         path === '/register' ||
                         path === '/supplier/login' ||
                         path.startsWith('/supplier/activate/');
      
      if (!isAuthPage) {
        localStorage.removeItem('artflow_token');
        localStorage.removeItem('artflow_type');
        window.location.href = '/';
      }
    }
    return Promise.reject(err);
  }
);

export default api;
